<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              Платежные поручения на комиссию партнера
              <p>"{{ currentPartner.title }} с id={{ currentPartner.id }}"</p>
              <p>"по договору №{{ currentPartner.contractNumber }} от {{ currentPartner.contractDate }}"</p>
            </div>
            <div class="row mt-3">
              <div class="col-lg-12">
                <table class="table table-hover" style="cursor: pointer;">
                  <thead>
                  <tr>
                    <th>ID</th>
                    <th>Дата ПП</th>
                    <th>Номер ПП</th>
                    <th>ID Пакета</th>
                    <th>Дата начала периода</th>
                    <th>Дата окончания периода</th>
                    <th>Сумма</th>
                    <th>Время формирования</th>
                    <th>Действия</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in this.partnerProfitOrdersData" :key="item.id">
                    <td>{{item.id}}</td>
                    <td>{{item.date ? new Date(item.date).toLocaleDateString('ru-RU') : ''}}</td>
                    <td>{{item.number}}</td>
                    <td>{{item.package_id}}</td>
                    <td>{{item.start_period ? new Date(item.start_period).toLocaleDateString('ru-RU') : ''}}</td>
                    <td>{{item.end_period ? new Date(item.end_period).toLocaleDateString('ru-RU') : ''}}</td>
                    <td>{{item.sum}}</td>
                    <td>{{new Date(item.updated_at * 1000).toLocaleString('ru-RU')}}</td>
                    <td>
                      <div @click="showForExport(item)" class="btn btn-sm btn-outline-success">
                        <i class="fas"></i> Развернуть
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <popup
        :closeButton="createPartnerProfitOrder.closeButton"
        :actionButton="createPartnerProfitOrder.actionButton"
        :actionClass="createPartnerProfitOrder.actionClass"
        :show="createPartnerProfitOrder.show"
        @closePopup="closeCreatePartnerProfitOrder"
        @actionPopup="generatePartnerProfitOrder"
    >
      <div slot="header">Создание платежного поручения</div>
      <div slot="body">
        <CreatePartnerProfitOrder
            ref="myChildCreatePartnerProfitOrder"
            @new-profit-order-created="newProfitOrderCreated"
        >
        </CreatePartnerProfitOrder>
      </div>
    </popup>

    <popup
        :closeButton="viewPartnerProfitOrder.closeButton"
        :actionButton="viewPartnerProfitOrder.actionButton"
        :actionClass="viewPartnerProfitOrder.actionClass"
        :show="viewPartnerProfitOrder.show"
        @closePopup="closeViewPartnerProfitOrder"
    >
      <div slot="header">Сформированное платежное поручение</div>
      <div slot="body">
        <ViewPartnerProfitOrder  ref="myChildViewPartnerProfitOrder">
        </ViewPartnerProfitOrder>
      </div>
    </popup>

  </div>

</template>

<script>

import axios from "axios";
import CreatePartnerProfitOrder  from "@/components/management/partners/CreatePartnerProfitOrder.vue";
import Popup from "@/components/Popup.vue";
import ViewPartnerProfitOrder from "@/components/management/partners/ViewPartnerProfitOrder.vue";
// import ViewPartnerProfitOrder from "@/components/management/partners/ViewPartnerProfitOrder.vue";
// import CreatePartner from "@/components/management/partners/CreatePartner.vue";

export default {
  name: "PartnerProfitOrdersList",
  components: {ViewPartnerProfitOrder, CreatePartnerProfitOrder, Popup},
  // components: {CreatePartner, CreatePartnerProfitOrder, Popup},
  mounted() {
  },
  props: {
    submitManagePartnerPrinters: Number
  },
  watch: {
    submitManagePartnerPrinters: function (val) {
      if (val > 0) {
        this.handleSubmitManagePartnerPrinters();
      }
    },
  },
  data() {
    return {
      submitPartnerProfitOrder: 0,
      createPartnerProfitOrder: {
        show: false,
        // closeButton: null,
        // actionButton: null,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },

      viewPartnerProfitOrder: {
        show: false,
        // closeButton: null,
        // actionButton: null,
        closeButton: this.$t('popularWords.close'),
        // actionButton: this.$t('popularWords.add'),
        // actionClass: "btn-success"
      },

      partnerProfitOrdersData: [
          {
            id: null,
            package_id: null,
            date: null,
            number: null,
            start_period: null,
            end_period: null,
            sum: null,
            updated_at: null,
            status: null,
          }
      ],
      currentPartner: {
        id: null,
        title: null,
        contractNumber: null,
        contractDate: null,
      }
    }
  },

  methods: {
    getPartnerProfitOrders() {
      axios
          .get(`/v1/partners/get-profit-orders?id=` + this.currentPartner.id)
          .then(resp => {
            this.partnerProfitOrdersData = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    setNullPartnerData() {
      this.currentPartner.id = null;
      this.currentPartner.title = null;
      this.currentPartner.contractDate = null;
      this.currentPartner.contractNumber = null;
    },
    setNullOrderList() {
      // this.partnerProfitOrdersData = [
      //   {
      //     id: null,
      //     date: null,
      //     number: null,
      //     start_period: null,
      //     end_period: null,
      //     sum: null,
      //     updated_at: null,
      //     status: null,
      //   }
      // ];
      this.partnerProfitOrdersData = null;
    },
    handleSubmitManagePartnerPrinters() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.partnerData.$touch();
      if (!this.$v.partnerData.$invalid) {
        this.$emit('submitManagePartnerPrinters', this.partnerData);
      }
    },

    showCreatePartnerProfitOrder(){
      this.$refs.myChildCreatePartnerProfitOrder.setNullFormDate();
      this.createPartnerProfitOrder.show = true;
    },
    closeCreatePartnerProfitOrder(){
      this.createPartnerProfitOrder.show = false;
    },
    generatePartnerProfitOrder(){
      this.$refs.myChildCreatePartnerProfitOrder.partnerProfitOrderData.partner_id = this.currentPartner.id;
      this.$refs.myChildCreatePartnerProfitOrder.generatePartnerProfitOrder();
      this.getPartnerProfitOrders();
      this.closeCreatePartnerProfitOrder();
    },
    showForExport(order){
      this.$refs.myChildViewPartnerProfitOrder.ppDataObject = order;
      this.$refs.myChildViewPartnerProfitOrder.ppData = JSON.stringify(order);
      this.viewPartnerProfitOrder.show = true;
    },
    closeViewPartnerProfitOrder(){
      this.viewPartnerProfitOrder.show = false;
      this.$refs.myChildViewPartnerProfitOrder.setNullFormData();
    },
    newProfitOrderCreated: function () {
      this.getPartnerProfitOrders();
      alert('Платежное поручение создано');
    }
  }
}
</script>

<style scoped lang="scss">

</style>